import clsx from 'clsx'
import PropTypes from 'prop-types'

import { Typography, Box } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import Stepper from '../../../ui/modules/stepper'
import * as CTTPropTypes from '../../../common/propTypes'

import useStyles from './styles'
import { STEPS_DATA, STEPS_DATA_CUSTOMS } from './constants'

const ShippingSend = ({ states, currentStep, onClickStep, children, hasCustom }) => {
  const t = useTranslations()
  const classes = useStyles()
  
  return (
    <Box>
      <Typography variant="h1" className={clsx('mainTitle', classes.mainTitle)}>
        {t('action:request-a-shipment')}
      </Typography>
      <Stepper
        steps={hasCustom?.custom ? STEPS_DATA_CUSTOMS : STEPS_DATA}
        states={states}
        currentStep={currentStep}
        onClickStep={onClickStep}
      >
        {children}
      </Stepper>
    </Box>
  )
}

ShippingSend.STATUS = Stepper.STATUS

ShippingSend.propTypes = {
  ...CTTPropTypes.stepper,
  children: PropTypes.node,
}

export default ShippingSend
